import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { InfrastructuresPage } from '@/features/admin/infrastructures/infrastructure-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Infrastructures d'exécution du tenant. */
export const Route = createFileRoute('/$tenant/resources/infrastructures/')({
  component: InfrastructuresRoute,
});

function InfrastructuresRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="infrastructures"
      crumbs={[{ label: t('nav.items.infrastructures') }]}
    >
      <InfrastructuresPage tenantId={tenant} />
    </ConsoleShell>
  );
}
